import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, getToken, formatApiError } from "@/lib/adminApi";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) {
      api.get("/auth/me").then(() => navigate("/admin")).catch(() => setToken(null));
    }
  }, [navigate]);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-bg text-bone">
      <div className="hero-glow pointer-events-none" style={{ top: "15%", left: "50%", transform: "translateX(-50%)", opacity: 0.4 }} />
      <div className="relative w-full max-w-md border p-10" style={{ borderColor: "var(--brass)", background: "var(--surface)" }}>
        <div className="flex items-center gap-3 mb-8">
          <svg width="26" height="26" viewBox="0 0 40 40" fill="none">
            <path d="M8 8 L20 32 L32 8" stroke="var(--brass)" strokeWidth="1.4" />
            <circle cx="20" cy="20" r="3" fill="var(--amber)" />
          </svg>
          <span className="eyebrow">Johnny Dram · Cellar Master</span>
        </div>
        <h1 className="font-display text-4xl leading-tight mb-8 text-bone">
          The <em className="italic" style={{ color: "var(--amber)" }}>keys</em> to the cellar.
        </h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <label className="eyebrow" htmlFor="email">Email</label>
            <input
              id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="bg-transparent border-b outline-none py-2 font-body text-lg text-bone"
              style={{ borderColor: "var(--brass)", cursor: "text" }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className="eyebrow" htmlFor="password">Password</label>
            <input
              id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="bg-transparent border-b outline-none py-2 font-body text-lg text-bone"
              style={{ borderColor: "var(--brass)", cursor: "text" }}
            />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-solid justify-center mt-2 disabled:opacity-60">
            {loading ? "Entering" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
